<template>
  <a-modal
    title="再利用"
    :visible="visible"
    :width="1200"
    :destroyOnClose="true"
    :centered="true"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        rowKey="processInstanceId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
        @change="handleTableChange"
      >
        <!-- 申請時間 -->
        <span slot="startDate" slot-scope="text, record">{{
          record.startDate | dateformat('YYYY-MM-DD HH:mm:ss')
        }}</span>

        <!-- 最近更新時間 -->
        <span slot="endDate" slot-scope="text, record">{{ record.endDate | dateformat('YYYY-MM-DD HH:mm:ss') }}</span>

        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <a @click="handleOpen(record)">{{ $t('disp.flow.detail') }}</a>
        </span>

        <!-- ステータス -->
        <span slot="taskStatus" slot-scope="text, record">
          <a-tag color="green" v-if="record.taskStatus == 'disp.flow.end'">{{ $t(record.taskStatus) }}</a-tag>
          <!-- <a-tag color="red" v-else-if="record.taskStatus == 'disp.flow.refuse'">{{ $t(record.taskStatus) }}</a-tag> -->
          <a-tag v-else-if="record.taskStatus == 'disp.flow.cancel'">{{ $t(record.taskStatus) }}</a-tag>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 申請モーダル：申請フォームを載せる -->
    <apply-modal ref="ApplyModal"></apply-modal>
  </a-modal>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import { flowMixin } from '@/mixins/flowMixin'
import { putAction, postAction, getAction } from '@/api/manage'

export default {
  name: 'ReuseModal',
  mixins: [tableMixin, flowMixin],
  components: {
    ApplyModal: () => import('./ApplyModal')
  },
  data() {
    return {
      description: '再利用一覧',
      // ログインユーザ情報
      loginUser: this.$store.getters.userInfo,
      visible: false,
      disableMixinSearchQuery: true,
      /* 検索条件-queryParamに文字列のタイプを定義しないように */
      queryParam: {},
      // テーブルタイトル
      columns: [
        {
          title: this.$t('disp.flow.applyId'),
          align: 'center',
          width: 100,
          dataIndex: 'processInstanceId',
          customRender: this.renderProcessInstanceId
        },
        {
          title: this.$t('disp.abstract'),
          align: 'left',
          customRender: this.renderSummary
        },
        // {
        //   title: this.$t('disp.flow.applyName'),
        //   dataIndex: 'processDefinitionName'
        // },
        {
          title: this.$t('disp.flow.starter'),
          align: 'center',
          width: 120,
          dataIndex: 'starterName'
        },
        {
          title: this.$t('disp.flow.startDate'),
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'startDate' }
        },
        {
          title: this.$t('disp.flow.lastUpdateDate'),
          align: 'center',
          width: 180,
          scopedSlots: { customRender: 'endDate' }
        },
        {
          title: this.$t('disp.status'),
          align: 'center',
          width: 110,
          scopedSlots: { customRender: 'taskStatus' }
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   width: 80,
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      url: {
        list: '/flow/reuse/list'
      }
    }
  },
  computed: {},
  methods: {
    tagColor(user) {
      return 'blue'
    },
    tagName(user) {
      return user.realname
    },
    handleOpen(record) {
      this.$refs.ApplyModal.title = record.processDefinitionName
      this.$refs.ApplyModal.component = record.component
      this.$refs.ApplyModal.procInstId = record.processInstanceId
      this.$refs.ApplyModal.taskId = record.id
      this.$refs.ApplyModal.status = record.taskStatus

      this.$refs.ApplyModal.handleOpen()
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      if (this.selectionRows.length > 0) {
        this.$emit('emit', this.selectedRowKeys[0])
        this.handleCancel()
      } else {
        this.$message.warning(this.$t('disp.rules.select'))
      }
    }
  }
}
</script>
